import {Dispatch, SetStateAction} from 'react'
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE, doMETHOD_UPDATE_TASK} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_TASK_STOPWATCH_GARMIN_STREAM_UPDATE = 'REQUEST_TASK_STOPWATCH_GARMIN_STREAM_UPDATE'
export const doREQUEST_TASK_STOPWATCH_GARMIN_STREAM_UPDATE = createDoRequestAction(
  REQUEST_TASK_STOPWATCH_GARMIN_STREAM_UPDATE,
)

export const requestTaskStopwatchGarminStreamUpdateActionCreators = {
  doREQUEST_TASK_STOPWATCH_GARMIN_STREAM_UPDATE,
}

interface Payload {
  payload: {
    requestId: string
    taskId: string
    color: string
    scheduleRepeat: boolean
    scheduleDescription: string
    reminderList?: Record<string, string>[]
    name: string
    description: string
    accEnable: boolean
    accHz: number
    tempTaskId: string
    timeLimitSeconds: number
  }
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>
}

export function* requestTaskStopwatchGarminStreamUpdate({payload, setRequestResult}: Payload): SagaIterator {
  debug('saga*requestTaskStopwatchGarminStreamUpdate')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        taskId: v.string().uuid().exist(),
        color: v.string().exist(),
        scheduleRepeat: v.boolean(),
        scheduleDescription: v.string().optional(),
        reminderList: v.array().optional(),
        name: v.string().exist(),
        description: v.string().optional(),
        accEnable: v.boolean().optional(),
        accHz: v.number().valid(25, 50, 100).optional().allow(null),
        timeLimitSeconds: v.number().required(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_STOPWATCH_GARMIN_STREAM_UPDATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {
    taskId,
    color,
    scheduleRepeat,
    scheduleDescription,
    reminderList,
    name,
    description,
    accEnable,
    accHz,
    timeLimitSeconds,
  } = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/task-stopwatch-garmin-stream-update`,
    accessToken,
    data: {
      taskId,
      color,
      scheduleRepeat,
      scheduleDescription,
      reminderList,
      name,
      description,
      accEnable,
      accHz,
      timeLimitSeconds,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_STOPWATCH_GARMIN_STREAM_UPDATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/task-stopwatch-garmin-stream-update',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  delete result.payload.enabled
  yield put(doMETHOD_UPDATE_TASK(result.payload))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_STOPWATCH_GARMIN_STREAM_UPDATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* taskStopwatchGarminStreamUpdateSaga() {
  yield takeEvery(REQUEST_TASK_STOPWATCH_GARMIN_STREAM_UPDATE as any, requestTaskStopwatchGarminStreamUpdate)
}
